import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./domain/reducers";
import { autoRehydrate } from "redux-persist";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { browserHistory } from "react-router";
import { apiService } from "./domain/apiService";
const ENABLE_DEV_TOOLS = process.env.ENABLE_DEV_TOOLS === "true";
const middlewares = [
    routerMiddleware(browserHistory),
    thunk
];
const composeEnhancers = ENABLE_DEV_TOOLS && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
const store = createStore(reducers, composeEnhancers(autoRehydrate(), applyMiddleware(...middlewares)));
apiService.setStore(store);
export default store;



// WEBPACK FOOTER //
// ./src/assets/scripts/appStore.ts